
const ParallaxData = cc.Class({
    name: 'ParallaxData',
    properties: {
        node: {
            default: null,
            type: cc.Node,
            notify: function() {
                if (this.node) {
                    this.origin = this.node.position.clone();
                }
            }
        },
        coef: 1,
        origin: cc.v3()
    }
});

cc.Class({
    extends: cc.Component,

    properties: {
        data: [ParallaxData]
    },
    ctor () {
        this.tweens = [];
    },


    setTo (toX, toY) {
        this.data.forEach(({ node, origin, coef }) => {
            const x = origin.x + toX * coef;
            const y = origin.y + toY * coef;
            node.x = x;
            node.y = y;
        });
    },

    moveTo (toX, toY = 0, time = 0.5, easing = 'sineInOut') {
        this.cleanTween();
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.data.forEach(({ node, origin, coef }) => {
                const x = origin.x + toX * coef;
                const y = origin.y + toY * coef;
                this.tweens.push(cc.tween(node).
                to(time, { x, y }, { easing }).
                call(this.cleanTween, this).
                start());
            });
        });
    },

    cleanTween () {
        this.tweens.forEach(tween => tween.stop());
        this.tweens.length = 0;
        if (this.resolve) {
            this.resolve();
            this.resolve = null;
        }
    },
});
